import { Stack } from "expo-router";

/**
 * Profile stack layout
 * Includes main profile, weekends, settings screens, and user profiles
 */
export default function ProfileLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="edit" />
      <Stack.Screen name="account" />
      <Stack.Screen name="weekends" />
      <Stack.Screen name="weekend/[id]" />
      <Stack.Screen name="notifications" />
      <Stack.Screen name="user" />
    </Stack>
  );
}

